import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiGetAppResponseBody } from '../../Apps';
import type { IApiActivateWPLeaderboardRequestBody } from '../WPLeaderboardApi.types';
import { useApi } from '~/lib/api/useApi';
import { appQueryKeyFactory } from '../../Apps/hooks/useAppQuery';
import { appsQueryKeyFactory } from '../../Apps/hooks/useAppsQuery';

export type IUseActivateWPLeaderboardMutationValues = {
  appId: string;
  body: IApiActivateWPLeaderboardRequestBody;
};

export const useActivateWPLeaderboardMutation = (): UseMutationResult<
  IApiGetAppResponseBody,
  unknown,
  IUseActivateWPLeaderboardMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.wpLeaderboard.activate(values.appId, values.body),
    onSuccess: async (updatedApp) => {
      queryClient.setQueryData(
        appQueryKeyFactory({
          appId: updatedApp._id,
        })!,
        updatedApp,
      );
      await queryClient.invalidateQueries({
        queryKey: appsQueryKeyFactory(),
      });
    },
  });
};
